<template>
  <v-app>
    <v-main>
      <div class="sign-in-cover">
        <div class="sign-in-cover-image"></div>
        <div class="sign-in-cover-bg"></div>
      </div>

      <div v-if="!dialog.mfa" class="sign-in animated fade-in bg-white-transparent-1" data-pageload-addclass="animated fadeIn">
        <!-- begin brand -->
        <div class="system-version"></div>
        <div class="sign-in-header">
          <div class="brand">
            <b class="f-w-700">PANDA</b> LOAN MANAGEMENT SYSTEM
            <small class="f-w-400"
              >Focus on Pre-Origination System™, Post-Origination System™ and Collection System™.
            </small>
          </div>
        </div>
        <!-- end brand -->
        <!-- begin sign-in-content -->
        <div class="sign-in-content">
          <div class="data-form">
            <div class="form-group">
              <v-text-field
                prepend-icon="person"
                name="login"
                label="Account Name"
                type="text"
                :rules="[rules.verifyAccount]"
                v-model="layoutData.current.account"
              ></v-text-field>
            </div>
            <div class="form-group">
              <v-text-field
                prepend-icon="vpn_key"
                name="password"
                label="Password"
                id="password"
                type="password"
                :rules="[rules.min]"
                v-model="layoutData.current.password"
                @keyup.enter="clientSignInEventHandler"
              ></v-text-field>
            </div>
            <div class="m-t-40 text-center">
              <v-btn
                text
                icon
                color="primary"
                class="size-100x100 m-0"
                @click="clientSignInEventHandler"
                :disabled="layoutData.isLoading"
                :loading="layoutData.isLoading"
              >
                <v-icon class="f-s-60">fingerprint</v-icon>
              </v-btn>
              <div class="m-v-10">
                <a @click="showForgotPasswordDialog">Forgot password</a>
              </div>
              <v-dialog v-model="dialog.forgotPassword" persistent max-width="50%">
                <forgot-pass-card @hideDialog="hideDialog"></forgot-pass-card>
              </v-dialog>
            </div>
          </div>
        </div>
        <!-- end sign-in-content -->
      </div>

      <v-dialog v-model="dialog.mfa" persistent max-width="50%">
                <MFACard @hideMFADialog="hideMFADialog" :email="email"></MFACard>
              </v-dialog>

      <div class="copyright">
        <span>COPYRIGHT &copy; 2019-2022 PANDA LOAN SYSTEM, <strong>SZT</strong> ALL RIGHTS RESERVED</span>
      </div>

      <v-dialog v-model="verification.display" persistent max-width="30%">
        <tfa-verification-dialog
          :verification = "verification"
        ></tfa-verification-dialog>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
import { AuthApi } from '@/api/pandaria'
import { Cache, Popup, Crypto, DataType, Tool } from '@/util/index'
import ForgotPassCard from '@/views/system/ForgotPassCard'
import MFACard from '@/views/system/MFACard'
import TfaVerificationDialog from '@/components/panda/common/dialog/TfaVerificationDialog'
import { TfaApi } from '@/api/v4/auth'
const cache = new Cache()
const popup = new Popup()
const tool = new Tool()
export default {
  components: {
    ForgotPassCard,
    TfaVerificationDialog,
    MFACard
  },
  data: () => ({
    layoutData: {
      current: {
        account: '',
        password: ''
      },
      isLoading: false
    },
    rules: {
      verifyAccount: function (value) {
        const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*$/
        if (reg.test(value)) {
          return true
        } else {
          return 'Please enter the correct account number'
        }
      },
      min: function (value) {
        if (value.length >= 6) {
          return true
        } else {
          return 'Min 6 characters'
        }
      },
      PasswordMin: function (value) {
        const regex = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,18}$')
        if (!regex.test(value)) {
          return false
        } else {
          return true
        }
      }
    },
    dialog: {
      forgotPassword: false,
      mfa: false
    },
    verification: {
      display: false,
      token: ''
    },
    tfaFlag: false,
    email: ''
  }),
  methods: {
    async clientSignInEventHandler () {
      const $this = this
      try {
        const { account, password } = this.layoutData.current
        if (account !== '' && password !== '') {
          if (this.rules.verifyAccount(account) === true && this.rules.min(password) === true) {
            if (this.rules.PasswordMin(password) !== true) {
              popup.popupForWarning('Your password is weak, please change it as soon as possible. Otherwise, subsequent logins will be affected')
            }
            this.layoutData.isLoading = true
            let accessToken
            let info
            await AuthApi.signIn(
              account,
              Crypto.md5(password),
              DataType.GrantTypeEnum.EMPLOYEE.value,
              DataType.SystemNameEnum.PANDA3,
              function (data) {
                if (typeof data === 'string') {
                  accessToken = data
                  cache.setAccessToken(accessToken)
                  window.getApp.$emit('APP_LOGIN_SUCCESS')
                } else {
                  info = data
                }
                // $this.verification.token = accessToken
                // $this.tfaFlag = true
              },
              function (result) {
                throw result.message
              }
            )
            if (info) {
              this.email = info.email
              this.showMFADialog()
              this.layoutData.isLoading = false
            }
          }
        }
        // if ($this.tfaFlag) {
        //   $this.tfaVerification()
        // }
      } catch (e) {
        popup.popupForWarning(e, null, function () {
          $this.layoutData.isLoading = false
        })
      }
    },
    showForgotPasswordDialog () {
      this.dialog.forgotPassword = true
    },
    hideDialog () {
      this.dialog.forgotPassword = false
    },
    tfaVerification () {
      const $this = this
      TfaApi.checkTfaValidation(null, function (data) {
        if (tool.isNotEmpty(data) && data.status === 1) {
          window.getApp.$emit('APP_LOGIN_SUCCESS')
        } else {
          $this.verification.display = true
        }
      }, function (result) {
        $this.verification.display = true
      })
    },
    showMFADialog () {
      this.dialog.mfa = true
    },
    hideMFADialog () {
      this.dialog.mfa = false
    }
  },
  mounted () {
    this.$eventBus.$on('reLoading', target => {
      this.layoutData.isLoading = false
    })
  },
  destroyed () {
    this.$eventBus.$off('reLoading')
  }
}
</script>

<style scoped lang="css">
.sign-in-cover,
.sign-in-cover-bg,
.sign-in-cover-image {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  transition: background 0.2s linear;
}
.sign-in-cover-image {
  width: 1920px;
  background: url('/static/images/page-cover/sign-in.jpg');
}
.sign-in-cover .sign-in-cover-bg {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.4));
}
.system-version:before {
  content: '3';
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 500px;
  line-height: .5;
  color: rgba(255, 255, 255, 0.2);
}
.copyright {
  width: 500px;
  position: absolute;
  bottom: 0;
  right: 10%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  padding: 10px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  line-height: 20px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
}
.sign-in {
  width: 500px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  color: #ccc;
  background-color: rgba(204, 204, 204, 0.24);
}
.sign-in .sign-in-header {
  width: initial;
  padding: 0 20px;
  margin: 0;
  top: 0;
  left: 0;
  right: 0;
  position: relative;
  font-weight: 300;
  color: #fff;
}
.sign-in .sign-in-header,
.sign-in .sign-in-header .brand,
.sign-in .sign-in-header .brand small {
  color: #fff;
}
.sign-in .sign-in-header .brand small {
  font-size: 14px;
  display: block;
  color: rgba(255, 255, 255, 0.5);
}
.sign-in .sign-in-header .brand {
  padding: 0;
  font-size: 28px;
  color: #fff;
}
.sign-in .sign-in-content {
  padding: 20px;
  color: #9ba8b4;
  width: initial;
  margin: initial;
}
.animated {
  -webkit-animation-duration: 0.6s;
  animation-duration: 0.6s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.fade-in {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-control-lg,
.input-group-lg > .form-control,
.input-group-lg > .input-group-append > .btn,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-prepend > .input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}
.form-control,
.form-control-with-bg .form-control,
.form-control.form-control-with-bg {
  background: rgba(255, 255, 255, 0.25);
}
.form-control {
  border: 1px solid transparent;
  box-shadow: none;
  font-size: 12px;
  line-height: 1.42857143;
  height: 34px;
  padding: 6px 12px;
  color: #fff;
}
.form-control-lg,
.input-group-lg > .form-control,
.input-group-lg > .input-group-append > .btn,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-prepend > .input-group-text,
select.form-control-lg:not([size]):not([multiple]) {
  height: 46px;
  padding: 10px 16px;
  line-height: 1.3333333;
  border-radius: 6px;
}
.form-control.form-control-lg,
.form-control.input-lg {
  font-size: 14px;
}
.sign-in .form-control {
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid transparent;
  color: #fff;
}

.form-group {
  margin-top: 20px;
  margin-bottom: 20px;
}
div .form-group:first-child {
  margin-top: 0px !important;
}
.setting-fab {
  border: 1px solid green;
  display: none !important;
}
</style>
